import React from "react";
import IntlMessages from "../../../util/IntlMessages";
import "./MyBoardsWidget.less";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBackUrl } from "../../../appRedux/actions/Auth";

interface SingleBoardProps {
   boardData: any;
   parentWidth: number;
}

const SingleBoard: React.FC<SingleBoardProps> = ({ boardData, parentWidth }) => {
   const dispatch = useDispatch();

   const getImageSize = () => {
      if (window?.innerWidth <= 530) {
         return 40;
      } else return 76;
   };

   const chooseBoardAdress = () => {
      if (boardData?.sheets?.[0]?.url) {
         return boardData?.sheets?.[0]?.url;
      } else {
         return boardData?.url || `/boards/${boardData?.id}/${boardData?.sheets[0]?.id}`;
      }
   };

   return (
      <Link
         onClick={() => dispatch(setBackUrl(window.location.pathname))}
         to={chooseBoardAdress()}
         className={
            parentWidth <= 450
               ? "my-boards-widget-container__single-board-narrow"
               : "my-boards-widget-container__single-board"
         }
      >
         <div className="my-boards-widget-container__single-board-icon">
            {boardData?.iconLink ? (
               <img
                  src={boardData?.iconLink}
                  style={{
                     maxHeight: "76px",
                     maxWidth: "76px",
                     width: getImageSize(),
                     height: getImageSize(),
                  }}
               />
            ) : null}
         </div>
         <h6
            className={
               parentWidth <= 450
                  ? "icon my-boards-widget-container__single-board-name-narrow"
                  : "icon my-boards-widget-container__single-board-name"
            }
         >
            <IntlMessages id={boardData?.name} />
         </h6>
      </Link>
   );
};

export default SingleBoard;
